import { TokenManager } from './tokenManager';

export const PLAN_HIERARCHY = { basic: 0, silver: 1, gold: 2 };

export const planRank = (plan) => PLAN_HIERARCHY[plan] ?? 0;

// Returns true when `current` is at least `required` (missing required => allowed).
export const planAtLeast = (current, required) =>
  planRank(current) >= planRank(required);

// Minimum plan required for an app route, matched by path prefix.
const ROUTE_RULES = [
  { prefix: '/crm', plan: 'gold' },
  { prefix: '/dashboard/estimates', plan: 'silver' },
  { prefix: '/dashboard/sales-orders', plan: 'silver' },
  { prefix: '/dashboard/proforma-invoices', plan: 'silver' },
  { prefix: '/dashboard/customer-pos', plan: 'silver' },
  { prefix: '/dashboard/invoices', plan: 'silver' },
  { prefix: '/dashboard/recurring-list', plan: 'silver' },
  { prefix: '/dashboard/recurring', plan: 'silver' },
  { prefix: '/dashboard/payments', plan: 'silver' },
  { prefix: '/dashboard/credit-notes', plan: 'silver' },
  { prefix: '/dashboard/debit-notes', plan: 'silver' },
  { prefix: '/dashboard/purchases', plan: 'silver' },
  { prefix: '/dashboard/purchase-orders', plan: 'silver' },
  { prefix: '/dashboard/vendors', plan: 'silver' },
  { prefix: '/dashboard/bills', plan: 'silver' },
  { prefix: '/dashboard/new-bill', plan: 'silver' },
];

export const getRequiredPlan = (pathname = '') =>
  ROUTE_RULES.find(
    (r) => pathname === r.prefix || pathname.startsWith(`${r.prefix}/`)
  )?.plan || null;

export const isRouteLocked = (pathname, plan = TokenManager.getPlan()) => {
  const required = getRequiredPlan(pathname);
  return !!required && planRank(plan) < planRank(required);
};
